<template>
  <confirm-modal
    :show="visible"
    placement="center"
    :close-on-overlay="false"
    :show-close="false"
    :title="t('common.pleaseRelogin')"
    :cancel-text="t('common.sessionAuthStay')"
    :confirm-text="t('common.sessionAuthRelogin')"
    @confirm="onRelogin"
    @cancel="onStay"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import ConfirmModal from '@/components/confirm-modal/index.vue';
import { useLoginUiStore } from '@/store/loginUi';

const { t } = useI18n();
const loginUi = useLoginUiStore();
const { sessionPromptVisible: visible } = storeToRefs(loginUi);

const onRelogin = () => {
  loginUi.confirmSessionRelogin();
};

const onStay = () => {
  loginUi.confirmSessionStay();
};
</script>
